var React = require( 'react' );
var PropTypes = require('prop-types');
var createReactClass = require('create-react-class');
var PlayList = require( './playList.jsx' );
var Section = require( './section.jsx' );
var PureRenderMixin = require('react-addons-pure-render-mixin');

var Hero = createReactClass({
	mixins: [PureRenderMixin],

  render: function(){
      var heroSection = this.props.education.filter(function(item) {
          return item.topic === 'how_common';
      })[0].sections[0];

    return (
		<section id="hero">
			<div className="row">
				<div className="medium-6 small-12 column">
					<PlayList gender={this.props.gender} video={this.props.featuredVideo} />
				</div>
				<div className="medium-6 small-12 column end">
					<div className="feature">
						<summary id="synopsis">
							<Section section={heroSection} />
						</summary>
					</div>
				</div>
			</div>
		</section>
    )
  }
});

Hero.propTypes = {
  title: PropTypes.string
};

module.exports = Hero;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/hero.jsx